import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';
import { ToastrService } from 'ngx-toastr';

import { ApiService } from '../../../ubi-core/ubi-core.module';
import { AnnouncementItem } from '../../domain/announcementItem';
import { RegisterMovementRequest } from '../../domain/registerMovementRequest';
import { Movement } from '../../domain/movement';
import { Damage } from '../../domain/damage';
import { GlobalState } from '../../../global.state';
import { debounce } from 'rxjs/operator/debounce';

declare var $: any;

@Component({
  selector: 'app-movement',
  templateUrl: './movement.component.html',
  styleUrls: ['./movements.component.scss']
})

export class MovementMobileComponent implements OnInit {
  private processing = false;
  private registerMovementRequest: RegisterMovementRequest;
  private movement: Movement;
  private customer: string;
  private community: boolean;
  private ships = [];
  private truckingCompanies = [];  
  private zones = [];
  private damageTypes = [];
  private damagesListHeight;
  private ship = {};
  private lastMovements = [];
  private announcementItems = [];
  private isMobile: boolean;
  private soldTo_ShipTo: string;
  private productCode_Designation: string;
  private visibleElements = {
    truckInfo: false,
    shipInfo: false,
    vesselDesignation: false,
    damagesListMobileButton: true,
    damagesList: false,
    recentMovements: true,
    announcementItems: false,
    zone: false,
    generateTruckLoadReportActionButton: false,
    closeAnnouncementActionButton: false,
    vesselInfo: false
  };
  private enabledElements = {
    damages: true
  };

  constructor(private _baseservice: ApiService, private route: ActivatedRoute, private router: Router,
    private modalService: NgbModal, private _state: GlobalState, protected toastr: ToastrService) {
    this.registerMovementRequest = new RegisterMovementRequest();
    this.isMobile = window.innerWidth < 501;

    const $resizeEvent = Observable.fromEvent(window, 'resize')
      .map(() => {
        return document.documentElement.clientWidth;
      })
      .debounceTime(200);
  }

  ngOnInit() {
    this.setupView();
    this._state.notifyDataChanged('backButton.changeState', this.isMobile);

    // Clear movements count in the top bar
    $('.content-top .movements-count').text('');
    $('.content-top .total-movements-count').text('');
    $('.content-top .movements-vessel-count').text('');    
  }

  private setupView() {
    this.route.params.subscribe(params => this.registerMovementRequest.MovementType = params['type']);
    switch (this.registerMovementRequest.MovementType) {
      case '1':
        $('.content-top .al-title').text('Entrada');
        this.visibleElements.truckInfo = true;
        this.visibleElements.zone = true;
        this.visibleElements.vesselInfo = true;
        this.getTruckingCompanies();
        this.getVesselsAndProcesses();
        this.getZones();
        break;
      case '2':
        $('.content-top .al-title').text('Carga');
        this.visibleElements.shipInfo = true;
        this.getVesselsAndProcesses();
        break;
      case '3':
        $('.content-top .al-title').text('Descarga');
        this.visibleElements.shipInfo = true;
        this.visibleElements.zone = true;
        this.getVesselsAndProcesses();
        break;
      case '4':
        $('.content-top .al-title').text('Saída');
        this.visibleElements.truckInfo = true;
        this.visibleElements.vesselInfo = true;
        this.getTruckingCompanies();
        this.getVesselsAndProcesses();
        break;
      case '5':
        $('.content-top .al-title').text('Carga direta');
        this.visibleElements.truckInfo = true;
        this.visibleElements.shipInfo = true;
        this.getTruckingCompanies();
        this.getVesselsAndProcesses();
        break;
      case '6':
        $('.content-top .al-title').text('Descarga direta');
        this.visibleElements.truckInfo = true;
        this.visibleElements.shipInfo = true;
        this.getTruckingCompanies();
        this.getVesselsAndProcesses();
        break;
      case '7':
        $('.content-top .al-title').text('Consulta de produto');
        this.visibleElements.damagesListMobileButton = false;
        this.visibleElements.recentMovements = false;
        this.visibleElements.vesselDesignation = true;
        this.setProductCodeFocus();
        break;
      default:
        this.router.navigateByUrl('mobile/movements');
    }
  }

  private getVesselsAndProcesses() {
    this._baseservice.setEntity('VesselAndProcesses/GetActiveVesselAndProcesses?movementType=' +
      this.registerMovementRequest.MovementType);

    this._baseservice.getAll().subscribe(
      data => this.ships = data,
      error => {
        console.log('Error getting vessels list: ' + error);
        this.toastr.error('Erro a obter a lista de navios.', '', { timeOut: 3000 });
      });
  }

  private getZones() {
    this._baseservice.setEntity('Zones/GetActiveZones');

    this._baseservice.getAll().subscribe(
      data => this.zones = data,
      error => {
        console.log('Error getting zone list: ' + error);
        this.toastr.error('Erro a obter a lista de zonas.', '', { timeOut: 3000 });
      });
  }


  private getTruckingCompanies() {
    this._baseservice.setEntity('TruckingCompanies');
    this._baseservice.getPage({ 'pageSize': 500, 'sortAsString': 'Designation' }).subscribe(
      response => this.truckingCompanies = response.data
      .filter((t: any) => !t.Inactive)
      .sort((a, b) => a.Designation.localeCompare(b.Designation)),
      error => {
        console.log('Error getting trucking companies list: ' + error);
        this.toastr.error('Erro a obter a lista de empresas de camionagem.', '', { timeOut: 3000 });
      });
  }

  private getDamageTypes() {
    if (this.movement == null) {
      return;
    }

    let productTypeId = null;

    if (this.movement.AnnouncementItemProduct != null &&
      this.movement.AnnouncementItemProduct.ProductTypeID != null) {
      productTypeId = this.movement.AnnouncementItemProduct.ProductTypeID;
    }

    const url = 'Damages/GetDamagesListByProductType?productTypeId=' + productTypeId;
    this._baseservice.setEntity(url);
    this._baseservice.getAll().subscribe(data => {
      if (this.movement.Damages != null && this.movement.Damages.length > 0) {
        data.forEach(damageType => {
          damageType.checked = this.movement.Damages.find(d => d.Id === damageType.Id) != null;
        });
      }

      this.damageTypes = data;

      if (this.isMobile) {
        this.damagesListHeight = $('.al-content-header').height() + $('.al-content-inner').height() + 'px';
      }
      this.visibleElements.damagesList = true;
    },
      error => {
        console.log('Error getting damage types: ' + error);
        this.toastr.error('Erro a obter a lista de tipos de avarias.', '', { timeOut: 3000 });
      });
  }

  private getRecentMovements() {
    this._baseservice.setEntity('Movements/GetRecentMovements');
    this._baseservice.postRequest(this.registerMovementRequest).subscribe(
      data => this.lastMovements = data,
      error => {
        console.log('Error getting last movements list: ' + error);
        this.toastr.error('Erro a obter a lista de movimentos.', '', { timeOut: 3000 });
      });            
  }

  private onShipChange(event: Event): void {
    this.isProductCodeEnabled(event);
    this.registerMovementRequest.ProductCode = '';
    const shipDropdown = <HTMLSelectElement>event.target;
    this.registerMovementRequest.Process = shipDropdown.options[shipDropdown.selectedIndex].getAttribute('data-process');
    this.registerMovementRequest.VesselName = shipDropdown.options[shipDropdown.selectedIndex].getAttribute('data-name');
    this.registerMovementRequest.VesselDesignation = shipDropdown.options[shipDropdown.selectedIndex].getAttribute('data-designation');
    this.registerMovementRequest.PortOfLoading = shipDropdown.options[shipDropdown.selectedIndex].getAttribute('data-port-of-loading');
    this.registerMovementRequest.PortOfDischarge = shipDropdown.options[shipDropdown.selectedIndex].getAttribute('data-port-of-discharge');
    this.registerMovementRequest.PortOfLoadingDescription =
      shipDropdown.options[shipDropdown.selectedIndex].getAttribute('data-port-of-loading-desc');
    this.registerMovementRequest.PortOfDischargeDescription =
      shipDropdown.options[shipDropdown.selectedIndex].getAttribute('data-port-of-discharge-desc');
    this.registerMovementRequest.EntryDate = shipDropdown.options[shipDropdown.selectedIndex].getAttribute('data-entry-date');    
  }

  private onProductCodeKeyDown(event) {
    const productCodeInput = <HTMLInputElement>event.target;
    const keycode = (event.keyCode ? event.keyCode : event.which);

    if (this.canReadCode()) {
      if (keycode === 9 || keycode === 13) {
        productCodeInput.blur();
      }
    } else {
      event.stopPropagation();
      this.clearProductCodeInput();
      return false;
    }
  }

  private onProductCodeChange(notFoundModalContent, productRegisteredModalContent): void {
    if (this.registerMovementRequest.MovementType === '7') {
      this.getProdcutDetail();
    } else {
      this.registerMovement(notFoundModalContent, productRegisteredModalContent);
    }
  }

  onProductCodePaste(e, notFoundModalContent, productRegisteredModalContent) {
    let types, pastedData;

    if (this.canReadCode() && e && e.clipboardData && e.clipboardData.types && e.clipboardData.getData) {
      types = e.clipboardData.types;

      if (types.indexOf && types.indexOf('text/plain') !== -1) {
        pastedData = e.clipboardData.getData('text/plain');

        e.stopPropagation();
        e.preventDefault();

        const productCode = <HTMLInputElement>document.getElementById('productCode');

        this.registerMovementRequest.ProductCode = pastedData;

        this.onProductCodeChange(notFoundModalContent, productRegisteredModalContent);
      }
    }
  }

  private registerMovement(notFoundModalContent, productRegisteredModalContent) {
    this._baseservice.setEntity('Movements/Register');

    if (this.registerMovementRequest.ProductCode !== '') {
      this.processing = true;
      if (this.registerMovementRequest.TruckRegistration != null) {
        this.registerMovementRequest.TruckRegistration = this.registerMovementRequest.TruckRegistration.toUpperCase();
      }

      if (this.registerMovementRequest.TruckTrailer != null) {
        this.registerMovementRequest.TruckTrailer = this.registerMovementRequest.TruckTrailer.toUpperCase();
      }

      this._baseservice.postRequest(this.registerMovementRequest).subscribe(data => {
        this.processing = false;

        if (data.Movement != null) {
          this.updateViewWithMovementInfo(data, productRegisteredModalContent);
        } else {
          // Force registration is not available for QR Codes
          if (this.registerMovementRequest.ProductCode.length <= data.BarCodeMaxLength) {
            this.visibleElements.damagesList = false;
            this.modalService.open(notFoundModalContent, { backdrop: 'static', keyboard: false }).result.then((result) => {
              if (result === 'Yes') {
                this.processing = true;
                this._baseservice.setEntity('Movements/ForceRegistration');
                this._baseservice.postRequest(this.registerMovementRequest).subscribe(response => {
                  this.processing = false;
                  this.updateViewWithMovementInfo(response, productRegisteredModalContent);
                },
                  error => {
                    console.log('Error registring movement: ' + error);
                    this.toastr.error('Erro a efetuar o registo do movimento.', '', { timeOut: 3000 });
                    this.processing = false;
                  });
              } else {
                this.clearProductCodeInput();
              }
            });
          } else {
            this.toastr.warning('Não foi encontrado nenhuma linha de anúncio para o QR Code inserido. Para poder registar produtos com QR Codes, as respectivas linha de anúncio devem existir em backoffice.', '', { timeOut: 7000 });
          }
        }
      },
        error => {
          console.log('Error registring movement: ' + error);
          this.toastr.error('Erro a efetuar o registo do movimento.', '', { timeOut: 3000 });
          this.processing = false;
        });
    }
  }

  private getProdcutDetail() {
    this.processing = true;
   
    var productcode_aux=(this.registerMovementRequest.ProductCode.startsWith("S")? this.registerMovementRequest.ProductCode.substring(1,this.registerMovementRequest.ProductCode.length-1)  : this.registerMovementRequest.ProductCode);

    this._baseservice.setEntity('AnnouncementItems/GetAnnouncementItemsInStockByProductCode?productCode=' + productcode_aux);

    this._baseservice.getAll().subscribe(response => {
      this.movement = new Movement();
      this.announcementItems = response;
      this.visibleElements.announcementItems = response.length > 1;

      if (response.length > 0) {
        this.movement.AnnouncementItemProduct = response[0];

        if (response[0].Announcement != null) {
          this.customer = response[0].Announcement.Customer != null ? response[0].Announcement.Customer.Designation : '';
          this.community = response[0].Announcement.Community != null ? response[0].Announcement.Community : false;
        }
        this.concatFields();
      } else {
        this.movement.AnnouncementItemProduct = null;
        this.productCode_Designation = null;
        this.toastr.warning('Produto não encontrado', '', { timeOut: 3000 });
      }

      this.processing = false;
      // Prepare to read the next item
      this.clearProductCodeInput();
    },
      error => {
        console.log('Error getting announcement item: ' + error);
        this.toastr.error('Erro a obter o detalhe do produto.', '', { timeOut: 3000 });
        this.processing = false;
        this.visibleElements.announcementItems = false;
        this.productCode_Designation = null;
        // Prepare to read the next item
        this.clearProductCodeInput();
      });
  }

  private isProductCodeEnabled(event: Event) {
    const canReadCode = this.canReadCode();
    const targetElement = <HTMLElement>event.target;

    if (canReadCode === true &&
      (targetElement.id !== 'truckRegistration' || this.registerMovementRequest.TruckTrailer)) {
      this.setProductCodeFocus();
    }
  }

  private canReadCode() {
    return (!this.visibleElements.shipInfo || this.registerMovementRequest.VesselAndProcessId != null) &&
      (!this.visibleElements.truckInfo ||
        (this.registerMovementRequest.TruckingCompanyId != null &&
          this.registerMovementRequest.TruckRegistration != null &&
          this.registerMovementRequest.TruckRegistration !== ''));
  }

  private updateViewWithMovementInfo(data, productRegisteredModalContent) {
    this.visibleElements.closeAnnouncementActionButton = false;
    this.visibleElements.generateTruckLoadReportActionButton = false;

    this.movement = data.Movement;
    this.customer = data.Customer != null ? data.Customer : '';
    this.community = data.Community != null ? data.Community : false;

    this.concatFields();

    if (this.movement.Damages == null) {
      this.movement.Damages = new Array<Damage>();
    }

    this.getRecentMovements();

    //$("#spLastMovsCount").html($("#fieldset-last-movements").find("datatable-body").attr("ng-reflect-row-count"));

    // Display damages list if the device is not mobile
    if (!this.isMobile) {
      this.getDamageTypes();
    }

    if (data.AlreadyRegistered) {
      this.enabledElements.damages = !this.isMobile;
      this.modalService.open(productRegisteredModalContent, { backdrop: 'static', keyboard: false }).result.then(() => {
        // Prepare to read the next item
        this.clearProductCodeInput();
      });
    } else {
      this.enabledElements.damages = true;
      this.toastr.success('Movimento registado com sucesso', '', { timeOut: 3000 });
      // Prepare to read the next item
      this.clearProductCodeInput();
    }

    switch (this.registerMovementRequest.MovementType) {
      case '1':
        $('.content-top .total-movements-count').text('T: ' + data.TotalMovementsCount);
      break;
      case '2':
      case '3':
        // Display movements count in the top bar for vessel movements
        $('.content-top .total-movements-count').text('T: ' + data.TotalMovementsCount + '/' + data.TotalAnnouncementItemsCount);
        $('.content-top .movements-count').text('A: ' + data.AnnoucementMovementsCount + '/' + data.AnnouncementItemsCount);

        if (this.movement.AnnouncementItemProduct != null &&
          this.movement.AnnouncementItemProduct.AnnouncementId != null &&
          this.movement.AnnouncementItemProduct.Announcement != null &&
          this.movement.AnnouncementItemProduct.Announcement.StatusID === 2) {
          // Display action button in the top bar for vessels movements to set the operation (load/unload) as terminated
          this.visibleElements.closeAnnouncementActionButton = true;
        }
        break;
      case '4':        
        console.log(data.TotalVesselMovementsCount);
        console.log(data);
        $('.content-top .total-movements-count').text('T: ' + data.TotalMovementsCount);
        //alterado por GA a 2024-12-12 
        $('.content-top .movements-vessel-count').text('N: ' + data.TotalVesselMovementsCount);
        // Display action button in the top bar for tuck load movements to generate truck load report id
        if (this.movement.AnnouncementItemProduct != null) {
          this.visibleElements.generateTruckLoadReportActionButton = true;
        }      
        break;
      case '6':
        // Display action button in the top bar for tuck load movements to generate truck load report id
        if (this.movement.AnnouncementItemProduct != null) {
          this.visibleElements.generateTruckLoadReportActionButton = true;
        }
        break;
    }
  }

  private concatFields() {
    if (this.movement != null && this.movement.AnnouncementItemProduct != null) {
      // Concatenate sold to and ship to fields
      this.soldTo_ShipTo = this.movement.AnnouncementItemProduct.SoldTo
        ? this.movement.AnnouncementItemProduct.ShipTo
          ? this.movement.AnnouncementItemProduct.SoldTo.Designation + ' / ' + this.movement.AnnouncementItemProduct.ShipTo.Designation
          : this.movement.AnnouncementItemProduct.SoldTo.Designation
        : this.movement.AnnouncementItemProduct.ShipTo
          ? this.movement.AnnouncementItemProduct.ShipTo.Designation
          : null;

      // Concatenate product code and designation
      this.productCode_Designation = this.movement.AnnouncementItemProduct.ProductCode +
        ' - ' + this.movement.AnnouncementItemProduct.ProductName;
    }
  }

  private changeProductCodeInputMode() {
    if (this.canReadCode()) {
      this.registerMovementRequest.ProductCode = '';
      this.setProductCodeFocus();
    }
  }

  private clearProductCodeInput() {
    this.registerMovementRequest.ProductCode = '';
    this.setProductCodeFocus();
  }

  private updateSelectedDamagesList(event: Event) {
    const checkbox = <HTMLInputElement>event.target;

    if (checkbox.checked) {
      if (this.movement.Damages.find(d => d.Id === parseInt(checkbox.name)) == null) {
        const damage = new Damage();
        damage.Id = parseInt(checkbox.name);
        damage.Designation = checkbox.parentElement.previousElementSibling.textContent;
        this.movement.Damages.push(damage);
      }
    } else {
      const damageIndex = this.movement.Damages.findIndex(d => d.Id === parseInt(checkbox.name));
      if (damageIndex > -1) {
        this.movement.Damages.splice(damageIndex, 1);
      }
    }
  }

  private onDamagesFormSubmit() {
    if (this.enabledElements.damages) {
      this.processing = true;
      this._baseservice.setEntity('Movements/SaveMovementDamages');
      this._baseservice.postRequest(this.movement).subscribe(
        data => {
          this.processing = false;
          this.visibleElements.damagesList = !this.isMobile;
          this.toastr.success('Gravação efectuada com sucesso', '', { timeOut: 3000 });
          this.setProductCodeFocus();
        },
        error => {
          this.processing = false;
          console.log('Error saving movement damages: ' + error);
          this.toastr.error('Erro a gravar a lista de avarias.', '', { timeOut: 3000 });
        });
    } else {
      this.visibleElements.damagesList = !this.isMobile;
      this.setProductCodeFocus();
    }
  }

  private openLastMovementDetail(item) {
    this._baseservice.setEntity('Movements/GetMovement');
    this._baseservice.getById(item.selected[0].Id).subscribe(data => {
      this.movement = data;
      this.enabledElements.damages = !this.isMobile;
      this.setProductCodeFocus();
      // document.getElementById('productCode').focus();

      if (!this.isMobile) {
        this.getDamageTypes();
      }
    },
      error => {
        console.log('Error geting movement detail: ' + error);
        this.toastr.error('Erro a obter o detalhe do movimento.', '', { timeOut: 3000 });
      });
  }

  private openAnnouncementItemDetail(item) {
    this.movement.AnnouncementItemProduct = item.selected[0];
    this.setProductCodeFocus();
  }

  private closeAnnouncement() {
    this.processing = true;
    this._baseservice.setEntity('Announcements/CloseAnnouncement?id=' + this.movement.AnnouncementItemProduct.AnnouncementId);
    this._baseservice.postRequest(this.movement.AnnouncementItemProduct.AnnouncementId).subscribe(
      response => {
        this.processing = false;
        this.toastr.success('Operação terminada com sucesso.', '', { timeOut: 3000 });
        // Hide action button
        this.visibleElements.closeAnnouncementActionButton = false;
      },
      error => {
        console.log('Error closing announcement: ' + error);
        this.toastr.error('Erro ao tentar terminar a operação.', '', { timeOut: 3000 });
        this.processing = false;
      }
    );
  }

  private generateTruckLoadReport() {
    this.processing = true;
    const seqNumberRequest = {
      'TruckingCompanyId': this.registerMovementRequest.TruckingCompanyId,
      'TruckRegistration': this.registerMovementRequest.TruckRegistration,
      'TruckTrailer': this.registerMovementRequest.TruckTrailer
    };
    this._baseservice.setEntity('Movements/GenerateTruckLoadSequenceNumber');
    this._baseservice.postRequest(seqNumberRequest).subscribe(
      response => {
        this.processing = false;

        if (response != null) {
          this.toastr.success('Guia nº ' + response + ' gerada com sucesso', '', { timeOut: 3000 });
          // Clear truck info fields
          this.registerMovementRequest.TruckingCompanyId = null;
          this.registerMovementRequest.TruckRegistration = null;
          this.registerMovementRequest.TruckTrailer = null;
        } else {
          this.toastr.warning('Não foi encontrado nenhum movimento para o camião seleccionado.', '', { timeOut: 3000 });
        }
      },
      error => {
        console.log('Error getting sequence number: ' + error);
        this.toastr.error('Erro na geração do número de guia.', '', { timeOut: 3000 });
        this.processing = false;
      }
    );
  }

  private setProductCodeFocus() {
    const productCodeInput = <HTMLInputElement>document.getElementById('productCode');

    setTimeout(function () {
      productCodeInput.readOnly = true;
      productCodeInput.focus();
      productCodeInput.readOnly = false;
    }, 1000);
  }

  private getRowClass(row) {
    return { 'datatable-row-lines': true };
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/mobile/movements/movement.component.ts